import { render, staticRenderFns } from "./withdrawChannel.vue?vue&type=template&id=005e0888&scoped=true&"
import script from "./withdrawChannel.vue?vue&type=script&lang=js&"
export * from "./withdrawChannel.vue?vue&type=script&lang=js&"
import style0 from "./withdrawChannel.vue?vue&type=style&index=0&id=005e0888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005e0888",
  null
  
)

export default component.exports